export default "/images/vendor/flag-icon-css/flags/1x1/lc.svg?7ac7d1c95113e30046c9ea00abfa1e35";